const experience = [
  {
    title: "Experienced Programmer",
    company: "Awe Interactive",
    startDate: "AUG 2023",
    endDate: "JUL 2025",
    categories: [
      {
        name: "Narrative FPS RPG - Unreal Engine 5",
        points: [
          "Took ownership of enhancing and maintaining the Editor Dialogue tool, including adding new features to trigger gameplay events based on dialogue choices",
          "Built a modular Interaction system using components and event dispatchers, enabling designers to set up object interactions entirely in Blueprints",
          "Implemented a customizable 3D in-game computer system using 3D widgets and a data-driven approach, allowing designers to configure terminals for different gameplay scenarios",
          "Prototyped and integrated a Toast system to display on-screen messages for events like pickups, quests, and levelling",
          "Developed Codex and Skills data systems with corresponding UI menus, enabling dynamic content management and player progression tracking",
          "Led all UI development efforts, integrating CommonUI framework and establishing a base widget architecture to simplify the creation of new UI elements",
          "Wrote libraries to connect C++ systems with Blueprint logic for smoother collaboration between engineering and design",
          "Refactored and optimized code across C++, Blueprints, and UMG widgets to improve performance and maintainability",
          "Wrote documentation aimed at designers, explaining how to use and extend each implemented system",
          "Supported junior and intermediate developers by answering questions, reviewing code, and helping them troubleshoot issues",
        ],
      },
    ],
  },
  {
    title: "Experienced Programmer",
    company: "Coconut Lizard",
    startDate: "FEB 2022",
    endDate: "JUL 2023",
    categories: [
      {
        name: "Action RPG - Bespoke C++ Engine",
        points: [
          "Effectively implemented mini-game gameplay features such as camera transition using C++ in a bespoke engine",
          "Collaborated closely with the design team to refine the game feel of a captivating board game prototype using Unreal Engine 5 UI Widgets",
        ],
      },
      {
        name: "Tools",
        points: [
          "Built a .NET WPF desktop application to manage Perforce proxy syncs, enabling the Ops team to control sync schedules, manage services, and monitor multiple proxies",
        ],
      },
    ],
  },
  {
    title: "Full Stack .NET Developer",
    company: "M&G Investments",
    startDate: "NOV 2016",
    endDate: "JAN 2022",
    categories: [
      {
        name: "Content Management System",
        points: [
          "Developed and fully owned a .NET MVC WebApp to support a content management platform used for client and regulatory reporting",
          "Created internal REST APIs as Azure Functions for data processing and validation from Excel or CSV format into SQL database storage",
        ],
      },
      {
        name: "Legacy Enhancements & Cloud Integration",
        points: [
          "Led a time-sensitive migration of Apigee Proxies from SaaS to PaaS by analyzing existing proxies, planning and scripting the transition in PowerShell",
          "Collaborated on a successful database migration project, writing data transformation scripts to convert JSON data into SQL-ready formats. Provided guidance for prioritization, enabling the seamless conversion of data",
        ],
      },
      {
        name: "Client Reporting, Data Provisioning & Governance",
        points: [
          "Developed Apigee Proxies as APIs to source and store data in a NoSQL database",
          "Implemented a client reporting solution by leveraging APIs as microservices, providing external parties with real-time data while ensuring efficient data access, compliance and reliable reporting capabilities",
          "Developed Azure Service Bus listeners to listen to message queues, filter required messages, process and feed the data into our databases",
        ],
      },
      {
        name: "Agile Practices & Team Growth",
        points: [
          "Ensured adherence to standards during project release in production by fostering collaboration among multiple teams",
          "Proactively identified areas for improvement within our agile practices, effectively communicating valuable ideas to enhance our development cycle",
          "Produced clear internal API documentation",
          "Acted as a go-to resource for other developers and business analysts, offering support on design decisions, implementation details and clear guidance on our systems",
          "Helped onboard new team members by sharing context, best practices, and codebase knowledge",
        ],
      },
    ],
  },
  {
    title: "IT Consultant",
    company: "FDM Group",
    startDate: "AUG 2014",
    endDate: "OCT 2016",
    categories: [
      {
        name: "Tools & Automation",
        points: [
          "Delivered a deployment automation tool for M&G Investments, streamlining production rollouts and reducing manual DevOps effort",
          "Consulted on projects with a focus on backend .NET development, scripting, and release pipeline tooling",
        ],
      },
    ],
  },
];

export default experience;
